import { render, staticRenderFns } from "./ReturnsSettingsTable.vue?vue&type=template&id=20eb91a2&scoped=true"
import script from "./ReturnsSettingsTable.vue?vue&type=script&lang=js"
export * from "./ReturnsSettingsTable.vue?vue&type=script&lang=js"
import style0 from "./ReturnsSettingsTable.vue?vue&type=style&index=0&id=20eb91a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eb91a2",
  null
  
)

export default component.exports